export const QUESTIONS = [
  {
    id: "q1",
    text: "How confident are you that you purchased the right life insurance?",
    options: [
      { label: "Completely confident", score: 3 },
      { label: "Mostly confident", score: 2 },
      { label: "Somewhat unsure", score: 1 },
      { label: "I have no idea", score: 0 },
    ],
  },
  {
    id: "q2",
    text: "Have you ever wondered whether there's a better option than the policy you currently own?",
    options: [
      { label: "Yes, many times", score: 0 },
      { label: "Occasionally", score: 1 },
      { label: "Not really", score: 2 },
      { label: "I don't currently have insurance", score: 0 },
    ],
  },
  {
    id: "q3",
    text: "If you discovered today that you could have had better coverage, more value, and paid less over your lifetime, how would you feel?",
    options: [
      { label: "Frustrated", score: 0, tag: "recover" },
      { label: "Disappointed", score: 0, tag: "recover" },
      { label: "Curious", score: 1, tag: "prosper" },
      { label: "It wouldn't bother me", score: 2 },
    ],
  },
  {
    id: "q4",
    text: "Which concern worries you the most?",
    options: [
      { label: "Paying premiums for decades and never benefiting personally", score: 0, tag: "recover" },
      { label: "My family not having enough protection", score: 0, tag: "protect" },
      { label: "Buying the wrong policy", score: 0, tag: "recover" },
      { label: "Running out of money during retirement", score: 0, tag: "prosper" },
      { label: "Paying unnecessary taxes", score: 0, tag: "prosper" },
    ],
  },
  {
    id: "q5",
    text: "Have you ever had a second opinion on your life insurance?",
    options: [
      { label: "Never", score: 0 },
      { label: "More than five years ago", score: 1 },
      { label: "Within the last five years", score: 2 },
      { label: "Yes, recently", score: 3 },
    ],
  },
  {
    id: "q6",
    text: "If your advisor never explained alternatives beyond traditional term insurance, would you want to know what you may have missed?",
    options: [
      { label: "Absolutely", score: 0, tag: "recover" },
      { label: "Probably", score: 1, tag: "recover" },
      { label: "Maybe", score: 2 },
      { label: "No", score: 3 },
    ],
  },
  {
    id: "q7",
    text: "Which best describes how you feel about your current insurance?",
    options: [
      { label: "I hope I made the right decision", score: 0 },
      { label: "I'm not sure my insurance still fits my life", score: 0 },
      { label: "I haven't looked at it in years", score: 0 },
      { label: "I'm completely confident in my strategy", score: 3 },
    ],
  },
  {
    id: "q8",
    text: "Would you prefer to make one smart insurance decision that could last the rest of your life?",
    options: [
      { label: "Yes, absolutely", score: 0, tag: "recover" },
      { label: "Probably", score: 1 },
      { label: "Maybe", score: 2 },
      { label: "No", score: 3 },
    ],
  },
  {
    id: "q9",
    text: "Which sounds more appealing?",
    options: [
      { label: "Lowest monthly payment", score: 2, tag: "protect" },
      { label: "Best long-term value", score: 1, tag: "recover" },
      { label: "Lifetime protection with flexibility", score: 1, tag: "recover" },
      { label: "Protection that also builds wealth", score: 0, tag: "prosper" },
    ],
  },
  {
    id: "q10",
    text: "If your insurance could continue even after you stopped making premium payments, would that interest you?",
    options: [
      { label: "Very interested", score: 0, tag: "recover" },
      { label: "Somewhat interested", score: 1, tag: "recover" },
      { label: "Not sure", score: 2 },
      { label: "Not interested", score: 3 },
    ],
  },
  {
    id: "q11",
    text: "If you could recover the value of your premiums while still keeping permanent coverage, would you want to learn how?",
    options: [
      { label: "Definitely", score: 0, tag: "recover" },
      { label: "Maybe", score: 1 },
      { label: "Not sure", score: 2 },
      { label: "No", score: 3 },
    ],
  },
  {
    id: "q12",
    text: "Imagine knowing your family would be protected no matter when you pass away, and never having to worry about your insurance again. How valuable would that peace of mind be?",
    options: [
      { label: "Priceless", score: 0, tag: "recover" },
      { label: "Very valuable", score: 1 },
      { label: "Somewhat valuable", score: 2 },
      { label: "Not important", score: 3 },
    ],
  },
  {
    id: "q13",
    text: "Which statement best describes your goal?",
    options: [
      { label: "Protect my family", score: 1, tag: "protect" },
      { label: "Protect my family and build wealth", score: 0, tag: "prosper" },
      { label: "Create tax-free retirement income", score: 0, tag: "prosper" },
      { label: "Leave a larger legacy", score: 0, tag: "prosper" },
    ],
  },
  {
    id: "q14",
    text: "If there were a better strategy than the one you currently own, would you want to know, before it was too late?",
    options: [
      { label: "Yes", score: 0, tag: "recover" },
      { label: "Probably", score: 1 },
      { label: "Maybe", score: 2 },
      { label: "No", score: 3 },
    ],
  },
  {
    id: "q15",
    text: "Which statement best describes you?",
    options: [
      { label: "I don't want to discover years from now that I bought the wrong policy", score: 0, tag: "recover" },
      { label: "I want to make one smart decision and never worry about life insurance again", score: 0, tag: "recover" },
      { label: "I want my insurance to become a financial asset, not just an expense", score: 0, tag: "prosper" },
      { label: "I'd like a professional review before making any changes", score: 1 },
    ],
  },
];

// Compute the score (0–100) and the recommended stage.
export function computeResult(answers) {
  // answers = { q1: optionIndex, ... }
  let raw = 0;
  const maxPerQ = 3;
  const tallies = { protect: 0, recover: 0, prosper: 0 };

  QUESTIONS.forEach((q) => {
    const idx = answers[q.id];
    if (idx == null) return;
    const opt = q.options[idx];
    raw += opt.score;
    if (opt.tag) tallies[opt.tag] = (tallies[opt.tag] || 0) + 1;
  });

  // Max possible raw ≈ sum of top score per q, compute dynamically
  const maxRaw = QUESTIONS.reduce(
    (a, q) => a + Math.max(...q.options.map((o) => o.score)),
    0
  );
  const confidence = Math.round((raw / maxRaw) * 100);

  // Recommended stage: whichever tag is highest; fall back on confidence
  let stage = "recover";
  const [top] = Object.entries(tallies).sort((a, b) => b[1] - a[1]);
  if (top && top[1] > 0) stage = top[0];
  else if (confidence >= 80) stage = "protect";
  else if (confidence >= 40) stage = "recover";
  else stage = "prosper";

  return { confidence, stage, tallies };
}

export const STAGE_META = {
  protect: {
    name: "Foundation Protection™",
    tagline: "Right coverage, right price, a strong floor.",
    body:
      "You're focused on making sure the basics are in place. A well-priced term policy, sized properly to your income, mortgage and family, is the fastest way to get to peace of mind. We can review your current coverage and confirm it still fits.",
  },
  recover: {
    name: "Money Back Life™",
    tagline: "Permanent coverage where you get your premiums back.",
    body:
      "You value certainty. Money Back Life™ gives you permanent coverage for life while limiting how long you pay premiums, and returning the value of those premiums to you. Peace of mind without the feeling of watching decades of payments vanish.",
  },
  prosper: {
    name: "Prosperity Life™",
    tagline: "Turn coverage into a tax-efficient asset.",
    body:
      "You see insurance as a financial instrument, not just protection. Prosperity Life™ pairs permanent coverage with tax-advantaged wealth accumulation and the option of tax-efficient retirement income, a strategy trusted by business owners and executives.",
  },
};
